import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import Subpage1 from '../views/Subpage1.vue'
import Subpage2 from '../views/Subpage2.vue'
import Subpage3 from '../views/Subpage3.vue'
import Subpage4 from '../views/Subpage4.vue'
import Subpage5 from '../views/Subpage5.vue'

const routes = [
  { path: '/', component: Home },
  { path: '/about', component: About },
  { path: '/products', component: Subpage1 },
  { path: '/contact', component: Contact },
  { path: '/products/audit', component: Subpage1 },
  { path: '/products/tax', component: Subpage2 },
  { path: '/products/accounting', component: Subpage3 },
  { path: '/products/consulting', component: Subpage4 },
  { path: '/products/hongkong', component: Subpage5 },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: About } // 通配符路由，放在最后
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router